import React, { useEffect } from 'react';
import data1 from '../../data/home/projects/projects1';
import { SlideshowLightbox, initLightboxJS } from 'lightbox.js-react';

function Projects() {
  useEffect(() => {
    initLightboxJS("D0A7-F8DA-8595-5EEA", "individual");
  }, []);

  const featuredProjects = data1.filter(item => item.isFeatured === true);

  return (
    <section className="tc-latest-cases-style1" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="container">
        <div className="content">
          <div className="row align-items-center mb-50">
            <div className="col-lg-8">
              <h2 className="fsz-45 mb-0">Featured Projects</h2>
            </div>
            <div className="col-lg-4 mt-4 mt-lg-0 text-lg-end">
              <a
                href="/portfolio"
                className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1"
              >
                <span>
                  See All Projects
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="cases-content">
            <div className="row">
              {featuredProjects.map((item, i) => (
                <div key={i} className="col-lg-6 mb-4">
                  <div
                    className="case-card fancybox"
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 8px 30px rgba(0, 0, 0, 0.12)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.08)';
                    }}
                  >
                    <a className="img" style={{ height: '350px', display: 'block', overflow: 'hidden' }}>
                      <SlideshowLightbox className="img-cover" showThumbnails={false}>
                        <img
                          src={item.img}
                          alt={item.title}
                          className="img-cover"
                          style={{ transition: 'transform 0.3s ease' }}
                        />
                      </SlideshowLightbox>
                    </a>
                    <div style={{ padding: '24px 28px 28px' }}>
                      <h3 style={{
                        fontSize: '22px',
                        fontWeight: '600',
                        marginBottom: '10px',
                        color: '#1a1a1a',
                      }}>
                        {item.title}
                      </h3>
                      {item.desc && (
                        <p style={{
                          fontSize: '15px',
                          lineHeight: '1.6',
                          color: '#666',
                          margin: 0,
                        }}>
                          {item.desc}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center mt-50">
            <a
              href="/portfolio"
              className="butn rounded-pill hover-bg-black bg-orange1 text-white"
            >
              <span>
                See All Projects
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
